import { Button } from '@hologram-dimension/button';
import { SIM_DETAILS, SIM_PARAM_NAME, withContext } from 'common-js/constants/paths';
import { type FC } from 'react';

interface ActivityHistoryDetailsTableRowProps {
  deviceName: string;
  tags: Array<{ name: string }>;
  iccid: string;
  imei: string;
  hologramSimId: HologramSimId;
  linkId: LinkId;
}

const ActivityHistoryDetailsTableRow: FC<ActivityHistoryDetailsTableRowProps> = ({
  deviceName,
  tags,
  iccid,
  imei,
  hologramSimId,
  linkId,
}) => (
  <tr className="Table__row">
    <td className="Table__cell ActivityHistoryDetailsTable__cell">
      <div className="Table__cell-content ActivityHistoryDetailsTable__cell-content">
        {deviceName ? (
          <Button
            variant="tertiary"
            className="ActivityHistoryDetailsTable__link"
            to={withContext(SIM_DETAILS.replace(`:${SIM_PARAM_NAME}`, `${hologramSimId}`))}
            id={`act-history-sim-details-link-${hologramSimId}`}
          >
            {deviceName}
          </Button>
        ) : (
          <div>No access to device</div>
        )}
        <div className="ActivityHistoryDetailsTable__subheader">
          {tags ? tags.map(({ name }) => name).join(', ') : 'SIM moved to new org'}
        </div>
      </div>
    </td>
    <td className="Table__cell ActivityHistoryDetailsTable__cell">
      <div className="Table__cell-content ActivityHistoryDetailsTable__cell-content">
        {iccid ? (
          <>
            <div>{iccid}</div>
            <div className="ActivityHistoryDetailsTable__subheader">{imei}</div>
          </>
        ) : (
          <>&ndash;</>
        )}
      </div>
    </td>
    <td className="Table__cell ActivityHistoryDetailsTable__cell">
      <div className="Table__cell-content ActivityHistoryDetailsTable__cell-content">
        {hologramSimId ?? <>&ndash;</>}
      </div>
    </td>
    <td className="Table__cell ActivityHistoryDetailsTable__cell">
      <div className="Table__cell-content ActivityHistoryDetailsTable__cell-content">
        {linkId ?? <>&ndash;</>}
      </div>
    </td>
  </tr>
);

export default ActivityHistoryDetailsTableRow;
